<script>
import config from "@/config.json";
import axios from 'axios';
import {post} from "@/assets/js/utils";
import Footer from "@/components/footer";
import Navbar from "@/components/navbar";


/**
 * Page-thankyou component
 */
export default {
  data() {
    return {
      order_id: "",
      lang: this.getLang(),
      order: {
        trade_status: 0
      },
      follow: "wechat"
    };
  },
  components: {
    Navbar,
    Footer,
  },
  mounted() {
    const query = this.$route.query;
    if (query.order_id === undefined && query.out_trade_no === undefined) {
      alert(this.$t('cart.param_error'));
      this.$router.push({name: "buy"});
      return;
    }
    this.order_id = query.order_id? query.order_id : query.out_trade_no;
    this.getOrderInfo();
  },
  methods: {
    async getOrderInfo() {
      try {
        const {order_id} = this;
        const data = await post(`${config.api.orderinfo}`, {order_id});
        if (data.errno === 0) {
          this.order = data.order;
        } else if (data.errno === 12) {
          await this.$router.push('/buy');
        }
      } catch (e) {}
    },
    showFollowModal(name) {
      this.follow = name;
      this.$bvModal.show("follow-modal");
    }

  }
};
</script>
<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <section class="bg-half bg-light d-flex align-items-center">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="text-center">
              <div
                class="icon d-flex align-items-center justify-content-center rounded-circle mx-auto"
                style="height: 90px; width: 90px"
                :class="{'bg-soft-primary': order.trade_status === 1, 'bg-soft-warning': order.trade_status !== 1}"
              >
                <i v-if="order.trade_status === 1" class="uil uil-thumbs-up align-middle h1 mb-0"></i>
                <i v-else class="uil uil-frown align-middle h1 mb-0"></i>
              </div>
              <h1 v-if="order.trade_status === 1" class="my-4 text-primary">{{$t('cart.success.title')}}</h1>
              <h1 v-else class="my-4 text-dark">{{$t('cart.fail.title')}}</h1>
              <p v-if="order.trade_status === 1" class="para-desc mx-auto"> {{$t('cart.success.detail')}} </p>
              <p v-else class="para-desc mx-auto"> {{$t('cart.fail.detail')}} </p>
              <router-link to="/" class="btn btn-soft-primary mt-3">{{$t("cart.home")}}</router-link>
              <router-link v-if="order.trade_status !== 1" :to="'/shop-cart?order_id=' + order_id" class="btn btn-soft-info mt-3 ml-2">{{$t("cart.repay")}}</router-link>
            </div>
          </div>
          <!--end col-->
        </div>
      </div>
    </section>
    <!--end section-->

    <div class="container pb-lg-4 mb-md-5 mb-4 mt-60">
      <div class="row justify-content-center">
        <div class="col-12 text-center">
          <div class="section-title">
            <h4 class="title mb-4"> {{$t('index.contact.title')}} </h4>
            <p class="para-desc mx-auto mb-0"> {{$t("index.contact.description")}} </p>

            <div class="row mt-4 text-left">
              <div class="col-md-6 mt-4" v-for="(item, index) in $t('index.contact.details')">
                <div class="media features feature-clean core-feature rounded shadow p-4">
                  <div class="icons text-primary text-center mx-auto" v-if="lang === 'zh'">
                      <span class="d-block rounded h3 mb-0" v-if="index === 0">
                        <font-awesome-icon :icon="['fab', 'weixin']"></font-awesome-icon>
                      </span>
                    <span class="d-block rounded h3 mb-0" v-if="index === 1">
                        <font-awesome-icon :icon="['fab', 'weixin']"></font-awesome-icon>
                      </span>
                    <span class="d-block rounded h3 mb-0" v-if="index === 2">
                        <font-awesome-icon :icon="['fas', 'comments']"></font-awesome-icon>
                      </span>
                    <span class="d-block rounded h3 mb-0" v-if="index === 3">
                        <font-awesome-icon :icon="['fab', 'qq']"></font-awesome-icon>
                      </span>
                  </div>
                  <div class="icons text-primary text-center mx-auto" v-if="lang === 'en'">
                      <span class="d-block rounded h3 mb-0" v-if="index === 0">
                        <font-awesome-icon :icon="['fab', 'slack']"></font-awesome-icon>
                      </span>
                    <span class="d-block rounded h3 mb-0" v-if="index === 1">
                        <font-awesome-icon :icon="['fab', 'twitter']"></font-awesome-icon>
                      </span>
                  </div>
                  <div class="media-body ml-4">
                    <h5 class="title text-dark">{{item.title}}</h5>
                    <p class="mt-2 mb-0">{{item.description}}</p>
                    <div class="text-primary" v-if="item.more" v-html="item.more"></div>
                    <a v-if="item.follow" class="text-primary" href="#" @click.prevent="showFollowModal(item.name)">{{item.follow}}</a>
                  </div>
                </div>
              </div><!--end col-->

              <b-modal id="follow-modal" size="sm" ref="login-modal" hide-footer
                       :title="$t('index.contact.follow_title')"
                       header-close-variant="white"
                       no-close-on-backdrop
                       header-class="border-0"
                       content-class="border-0" centered >
                <div v-if="follow==='wechat'"><img src="images/index/wechat-qrcode.png" class="img-fluid" alt=""></div>
                <div v-if="follow==='qq'"><img src="images/index/qq-group-qrcode.png" class="img-fluid" alt=""></div>
              </b-modal>

            </div><!--end row-->
          </div>
        </div>
        <!--end col-->
      </div>
      <!--end row-->
    </div>
    <!--end container-->

    <Footer />

  </div>
</template>
